import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-2', className)}>
      <div className="min-w-0 space-y-1">
        <h1 className="text-3xl font-black tracking-tight sm:text-4xl bg-gradient-to-r from-gray-900 to-gray-500 dark:from-white dark:to-gray-400 bg-clip-text text-transparent pb-1">
          {title}
        </h1>
        {description ? <p className="text-sm font-medium text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2 items-center mt-2 sm:mt-0">{actions}</div> : null}
    </div>
  );
}
